import axios from 'axios'
const url = window.payment_api
const urlBoleto = window.payment_api_boleto_
const payment_api = window.payment_api
const urlPix = window.payment_api_pix
const urlCard = window.payment_api_card

export const card = data =>
   axios.post(`${urlCard}pay/card`, data)

export const boleto = data =>
    axios.post(`${urlBoleto}pay/boleto`, data)


export const pay_across = data =>
axios.post(`${payment_api}pay_across/${data.token}`, data)


export const pix = data =>
axios.post(`${urlPix}pix/${data.token}`, data)

export const pixRede = data =>
axios.post(`${urlPix}pixRede/${data.token}`, data)

export const local = data =>
axios.post(`${url}local/${data.token}`, data)

export const free_first = data =>
axios.post(`${url}free_first/${data.token}`, data)

export const passport = data =>
axios.post(`${url}passport/${data.token}/${data.pass}`, data)

export const pay_program = data =>
axios.post(`${url}pay_program/${data.token}/${data.program}`, data)





// WEBPACK FOOTER //
// ./src/App/utils/payment.js